import React, { useState } from "react";
import "./VisaModal.css";

const VisaModal = ({ isOpen, onClose, onProceed }) => {
  const [isChecked, setIsChecked] = useState(false); 
  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  return (
    <>
      {isOpen && (
        <div className="visa-modal" onClick={onClose}>
          <div className="visa-modal-content">
            
            <div style={{display:'flex',alignSelf:'center',justifyContent:'center',fontSize:'24px',fontWeight:'700',padding:'15px'}}>Terms and Conditions</div>
            <p>
              Welcome to Vigovia! By using our services, you agree
              to the following terms and conditions. Please read them carefully.
            </p>
            <ol>
              <li>
                <div>Acceptance of Terms:</div> By accessing and using our
                website, you agree to be bound by these terms and any additional
                terms referenced herein.
              </li>
              <li>
                <div>Service Description:</div> Vigovia
                provides users with travel-related services, including but not
                limited to flight bookings, hotel reservations, and travel
                itineraries.
              </li>
              <li>
                <div>User Responsibilities:</div> You agree to use the website for lawful purposes only. Any fraudulent, illegal, or abusive behavior is strictly prohibited. You are responsible for providing accurate and up-to-date information for bookings.
              </li>
              <li>
                <div>Booking and Payments</div> All bookings are subject to availability and confirmation from the service provider. Prices are subject to change and may vary. Payment terms, including cancellation policies, are provided at the time of booking.
              </li>
            </ol>
            <div className="terms-acceptance">
              <input
                type="checkbox"
                id="accept-terms"
                checked={isChecked}
                onChange={handleCheckboxChange}
              />
              <label htmlFor="accept-terms">I accept the terms and conditions</label>
            </div>
            <div className='ctacont'style={{display:'flex',justifyContent:'center',marginTop:'20px',}}>
                <button
                style={{backgroundColor:'#541c9c !important'}}
                className="ctabutton"
                onClick={onProceed}
                disabled={!isChecked} // Disable button if checkbox is not checked
                >
                Proceed
                </button>
            </div>

          </div>
        </div>
      )}
    </>
  );
};

export default VisaModal;